import React, { useState, useEffect, useContext } from 'react';

import style from '../../css/Product.module.css';
import PackageUpgrade from './PackageUpgrade';
import Invoice from './BillUpgrade';
import Cookies from "js-cookie";
import axios from "axios";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import PaymentOptions from '../PaymentMethods/PaymentMethods';
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';

const ParentUpgrade = () => {
    const [packages, setSelectedPackage] = useState([]);//1
    const [data, setData] = useState(null);
    const [cycle, setcircle] = useState(null);
    const [totalPrice, setTotalPrice] = useState(null);
    const [subtotal, setSubtotal] = useState(null);
    const [curentPlan, setCurrentplan] = useState(null);
    const [backupPrice, setbackupPrice] = useState(null);
    const [option, setoption] = useState("");
    const [taxAmount, setTaxAmount] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState(null);
    const { t } = useTranslation();
    useLanguage();
    console.log("option", option)

    const handleSelectedPackage = (pkg) => {
        setSelectedPackage(pkg)
    };
    const { orderID } = useParams();
    const calculateRemainingCycle = (startDate, periods) => {
        if (!startDate || !periods) return null;

        const start = dayjs(startDate);
        const end = start.add(periods, "month");
        const now = dayjs();

        if (now.isAfter(end)) {
            return { remainingDays: 0 };
        }

        const diffInDays = end.diff(now, "day");

        return { remainingDays: diffInDays };
    };

    const getPackagePriceByPeriod = (pkg, periods) => {
        if (!pkg || !periods) return 0;

        const priceMap = {
            1: pkg.monthly,   // 1 tháng
            3: pkg?.quarterly,
            6: pkg?.biannual,
            12: pkg.annual,   // 12 tháng
            24: pkg.biennial, // 24 tháng
            36: pkg.triennial, // 36 tháng
            48: pkg.quadrennial, // 48 tháng
            60: pkg.quinquennial // 60 tháng
        };

        return priceMap[periods] || (pkg.monthly * periods); // Nếu không có thì nhân theo tháng
    };

    const calculateTotalPrice = (selectedPackage, periods) => {
        if (!selectedPackage || !periods) return 0;

        const basePrice = getPackagePriceByPeriod(selectedPackage, periods);

        // console.log("basePrice", basePrice)
        // const discountMap = { 6: 5, 12: 10, 24: 15, 36: 20, 48: 25, 60: 30 };
        // const discountPercentage = discountMap[periods] || 0;

        // return basePrice * (1 - discountPercentage / 100);
        return basePrice
    };
    const calculateToPackageCurrent = (selectedPackage, periods) => {
        if (!selectedPackage || !periods) return 0;

        const basePrice = getPackagePriceByPeriod(selectedPackage, periods);
        // const discountMap = { 6: 5, 12: 10, 24: 15, 36: 20, 48: 25, 60: 30 };
        // const discountPercentage = discountMap[periods] || 0;

        return basePrice;
    };



    useEffect(() => {
        if (!packages || !data) return;

        const packagecurrent = calculateToPackageCurrent(data.package, data.periods);
        setCurrentplan(packagecurrent);

        console.log("Current package:", packagecurrent);

        if (data.periods > 0) {
            const packagenew = calculateTotalPrice(packages, data.periods);
            console.log("packagenew", packagecurrent * (data?.periods));

            let pricepackage = (packagenew * (data?.periods) - packagecurrent * (data?.periods)) * (cycle?.remainingDays / (data?.periods * 30));

            // Làm tròn lên bậc nghìn gần nhất
            const roundedPrice = Math.ceil(pricepackage / 1000) * 1000;
            console.log("roundedPrice", roundedPrice)
            setTotalPrice(packagenew);

            let backupPrice = 0;
            if (data.backup === 1) {
                console.log("packages.price_storage:", packages);
                console.log("cycle.remainingDays:", cycle?.remainingDays);
                console.log("data.periods:", data?.periods);

                backupPrice = (packages?.price_storage) * (cycle?.remainingDays / (data?.periods * 30));
                backupPrice = Math.ceil(backupPrice / 100) * 100;
                setbackupPrice(backupPrice);
                console.log("backupPrice", backupPrice);
            }
            const subtotal = roundedPrice + backupPrice * (data?.periods)
            let taxAmount;
            let paymentAmount;

            if (subtotal > 0) {
                taxAmount = subtotal * 0.1;
                paymentAmount = taxAmount + subtotal
            }
            else {
                taxAmount = 0;
                paymentAmount = taxAmount + subtotal
            }

            setTaxAmount(taxAmount);
            setPaymentAmount(paymentAmount);

            setSubtotal(subtotal);
        } else {
            console.error("Invalid data.periods value:", data.periods);
        }
    }, [packages, data, cycle]);




    console.log("totalPrice", totalPrice)

    const fetchData = async () => {
        const token = Cookies.get("Token");
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/v1/order-details/${orderID}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }

            );
            console.log("response.data.order_details", response.data.order_details);

            setData(response.data.order_details);
            if (response.data.order_details.start_date) {
                const cycle = calculateRemainingCycle(response.data.order_details.start_date, response.data.order_details.periods);
                setcircle(cycle);
            }
        } catch (err) {
        } finally {
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    // console.log("cycle", cycle);
    console.log("cycle", cycle)
    const handleOnSelectedOption = (item) => {
        setoption(item)
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div
                    className="col-12 col-xl-9 col-lg-9 mx-auto mb-4"
                    style={{ width: "78.16667%" }} // 9.5/12 * 100%
                >
                    <div className={style.section}>
                        <div>
                            <h5>
                                {t("Choose Plan")}
                                <span
                                    style={{
                                        color: "red",
                                        position: "relative",
                                        top: "-5px",
                                        fontSize: "15px",
                                    }}
                                >
                                    *
                                </span>
                            </h5>
                        </div>
                        <PackageUpgrade onSelectedPackage={handleSelectedPackage} currentplan={curentPlan}
                            pricepupgrade={totalPrice} currentpackageid={data?.package?.id} storage={data?.package?.storage} />
                    </div>

                    {paymentAmount > 0 && (
                        <div className={style.section}>
                            <h5>{t("Choose Payment")}*</h5>
                            <PaymentOptions OnSelectedOption={handleOnSelectedOption}
                                totalAmount={paymentAmount}
                            />
                        </div>
                    )}


                </div>


                <div className="col-12 col-lg-2 d-flex justify-content-end me-auto">
                    <div className="w-100">
                        <Invoice
                            // onChildError={handleChildError} 
                            // packages={packages}
                            // baseAmount={baseAmount}
                            // totalAmount={totalAmount}
                            // selectedproduct={serverchose}
                            // selectedpackage={packages}
                            // selectedCycle={data?.periods}
                            // selectedChildSystem={selectedChildSystem}
                            // selectednameversion={selectednameversion}
                            // pricekm={pricekm}
                            // isChecked={isChecked}
                            currentpackageid={data?.package?.id}
                            currentpackagename={data?.package?.name}

                            order_detailsID={orderID}
                            package={packages}
                            currentplan={curentPlan}
                            pricepupgrade={totalPrice}

                            backup={data?.backup}
                            // backupPrice={backupPrice}
                            // backupselected={pricebackup?.isSelected}
                            // postdiscount={postdiscount}
                            // regions={selectedRegion}
                            // hostname={hostname}
                            remainingDays={cycle?.remainingDays}
                            cycel_upgrade={data?.periods}
                            subtotal={subtotal}
                            backupPrice={backupPrice}
                            taxAmount={taxAmount}
                            paymentAmount={paymentAmount}
                            option={option}

                        />
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ParentUpgrade;
